export const videos = [
    {
        _id: "Nc6PyUiY7sw",
        title: "7 DAYS IN SYRIA IN 2022",
        description:
          "A few months ago I had the privilege of being able to enter and see parts of western Syria. We went to see a few of the country’s major cities and ancient historical sights. Our trip was very emotionally challenging but also beautiful in many ways. Meeting Syrians, hearing their stories and capturing a small part of what the country looks like today was not a simple goal but one I hope you will enjoy joining me on. Sending lots of love to all of the Syrians of the world. Thank you for welcoming me and teaching me about your culture.",
        creator: "Yes Theory",
        category: "Adventure",
        uploaded: "Jul 24 2022",
        comments: [
          {
            user: "John Doe",
            comment:
              "Let's go 💪🏻",
            color: "blue",
          },
          {
            user: "John Wick",
            comment:
              "Loved this video. A brilliantly visual and fun-to-watch video!",
            color: "brown",
          },
        ],
      },
    {
        _id: "gFQNPmLKj1k",
        title: "How to Invest for Beginners",
        description:
          "Hey friends, in this video I'll give you a complete breakdown of how to get started with investing your hard earned cash, what various terms mean in the financial world and how to avoid taking high risks.",
        creator: "Ali Abdaal",
        category: "Investing",
        uploaded: "Oct 11 2020",
        comments: [
          {
            user: "Stonks",
            comment:
              "Let's go 💪🏻",
            color: "red",
          },
          {
            user: "John Wick",
            comment:
              "Loved this video. A brilliantly visual and fun-to-watch video!",
            color: "brown",
          },
        ],
      },
    {
        _id: "yNaN5kYTNLY",
        title: "Complete Financial Planning for your 20s! | Investing for Beginners 2021",
        description:
          "How to invest in your 20s? How to pick the right investment option? What are the top investing mistakes to avoid?",
        creator: "warikoo",
        category: "Investing",
        uploaded: "Jan 19 2021",
        comments: [
          {
            user: "Stonks",
            comment:
              "Let's go 💪🏻",
            color: "red",
          },
          {
            user: "John Wick",
            comment:
              "Loved this video. A brilliantly visual and fun-to-watch video!",
            color: "brown",
          },
        ],
      },

    {
        _id: "BTOHpoC-XsE",
        title: "I wish I knew this in my 20s",
        description:
          "This is how compound interest should be taught in school. Instead of memorizing a formula, teach children about the practical applications.",
        creator: "Honestly by Tanmay Bhat",
        category: "Investing",
        uploaded: "Mar 26 2021",
        comments: [
          {
            user: "Stonks",
            comment:
              "Let's go 💪🏻",
            color: "red",
          },
          {
            user: "John Wick",
            comment:
              "Loved this video. A brilliantly visual and fun-to-watch video!",
            color: "brown",
          },
        ],
      },
    {
        _id: "-mt8aNy1M00",
        title: "Finding the Lost Largest Pyramid in the World",
        description:
          "Here is our second documentary. It’s a story about Ammar’s dream to climb the Pyramid of Giza and where that actually led him to...a dream he never knew he had, deep in the jungles of Guatemala. Thank you for those of you who supported the paywall for the past month, you made this doc and future ones possible for us. Thank you to all of you for supporting our dreams. Hope you enjoy the film now here on YouTube!",
        creator: "Yes Theory",
        category: "Adventure",
        uploaded: "Oct 15 2019",
        comments: [
          {
            user: "Stonks",
            comment:
              "Let's go 💪🏻",
            color: "red",
          },
          {
            user: "John Wick",
            comment:
              "Loved this video. A brilliantly visual and fun-to-watch video!",
            color: "brown",
          },
        ],
      },

      {
        _id: "GaC9m93ACP8",
        title: "THE MAN WHO MAKES MORE PEOPLE DREAM! | KUNAL SHAH on Money talks!",
        description:
          "From living in a 100 sqft apartment to building multiple companies, how did Kunal Shah become Kunal Shah? Why does he do what he does? What is he truly chasing if he is not chasing money? I sit down with Kunal Shah to talk about things you perhaps would not have heard before; and am sure you would find the conversation as enriching as I did, while speaking to him.",
        creator: "warikoo",
        category: "Business",
        uploaded: "Jul 23 2022",
        comments: [
          {
            user: "John Wick",
            comment:
              "Loved this video. A brilliantly visual and fun-to-watch video!",
            color: "brown",
          },
        ],
      },

      {
        _id: "cdZZpaB2kDM",
        title: "Elon Musk talks Twitter, Tesla and how his brain works — live at TED2022",
        description:
          "In this unedited conversation with head of TED Chris Anderson, Elon Musk — the head of Tesla, SpaceX, Neuralink and The Boring Company — digs into the recent news around his bid to purchase Twitter and gets honest about the biggest regret of his career, how his brain works, the future he envisions for the world and a lot more.",
        creator: "TED",
        category: "Business",
        uploaded: "Apr 14 2022",
        comments: [
          {
            user: "John Wick",
            comment:
              "Loved this video. A brilliantly visual and fun-to-watch video!",
            color: "brown",
          },
        ],
      },

      {
        _id: "j9qGmO8Yy-Y",
        title: "Sundar Pichai, CEO of Google and Alphabet",
        description:
          "\"You have to encourage innovation. Companies become more conservative  in decision making as you grow...be okay with failure and reward effort, not outcomes.\" In this View From The Top interview, CEO of Google and Alphabet, Sundar Pichai, speaks to Archana Sohmshetty, MBA '22, about the impact of access to technology, humanity's challenge to harness it, and how Google is sustainably defining the future of work.  \"When you see the appetite and the desire for people to make their lives better by gaining access to technology, that is what compels me to go beyond.\" says Pichai.",
        creator: "Stanford Graduate School of Business",
        category: "Business",
        uploaded: "Apr 27 2022",
        comments: [
          {
            user: "John Wick",
            comment:
              "Loved this video. A brilliantly visual and fun-to-watch video!",
            color: "brown",
          },
        ],
      },
      {
        _id: "ErPsyBUCijM",
        title: "Legend of Atlantis (Full Episode) | Drain the Oceans",
        description:
          "Exciting evidence emerges of civilizations lost for centuries under the waves, from mysterious underwater pyramids off the coast of Japan to the fabled city of Atlantis itself. Using cutting-edge graphics to reveal what's actually lying on the seafloor, and insight from the world's top marine archaeologists, Drain the Oceans finds the answers.",
        creator: "National Geographic",
        category: "Adventure",
        uploaded: "Dec 31 2020",
        comments: [
          {
            user: "John Wick",
            comment:
              "Loved this video. A brilliantly visual and fun-to-watch video!",
            color: "brown",
          },
        ],
      },
]